import { render, staticRenderFns } from "./TrainingFailed.vue?vue&type=template&id=6cbaeb20"
import script from "./TrainingFailed.vue?vue&type=script&lang=js"
export * from "./TrainingFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports